export const RouteNames = {
  Home: 'home',
  Privacy: 'privacy',
  Cookies: 'cookies',
  BlogPost: 'blog-post',
  Customer: 'customer',
  PreCustomer: 'pre-customer',
  QrCheck: 'qr-check',
  MobileAppRegistration: 'mobileapp-registration',
  VendonTopUp: 'vendon-topup',
} as const;

export type RouteName = (typeof RouteNames)[keyof typeof RouteNames];
